<!-- <form class="role-list">
  <mat-form-field>
    <input type="text" [placeholder]="placeHolder" aria-label="Number" matInput [formControl]="myControl"
      [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let role of filteredRoles | async" [value]="role">
        {{ role.name_ }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form> -->

<form class="role-list">
  <mat-form-field>
    <mat-select [formControl]="myControl">
      <mat-option *ngFor="let role of roles" [value]="role">
         {{role?.name_}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form> 